class PrintView {

    constructor(onExportToPDF) {
        this.exportBtn = $('.app-export-to-pdf');
        this.exportBtn.click(onExportToPDF);
        this.sourceLogo = $('.sidebar .logo');
        this.sourceCalendar = $('.calendar');

        this.rootNode = $('.app-print');
        this.printLogo = $('.print-logo');
        this.printPlanUrl = $('.print-plan-url');
        this.printSite = $('.print-site');
        this.printCalendar = $('.print-calendar');
        this.printCalendarImg = $('.print-calendar-img');
        this.printQrCode = $('.print-qrcode');
        this.printQrCodeImg = $('.print-qrcode-img');
        this.printScheduleSummary = $('.print-schedule-summary');
        this.printDetails = $('.print-details');
    }
}
